import i18n from "../../i18n";

import Logo from "../../assets/GrECo_Logo_small.jpg";

import { logout } from "../../service/GraphService";
import { getHeaderConfig } from "./utils";

import { useTranslation } from "react-i18next";

import GrecoHeader from "components/GrecoHeader/GrecoHeader";
import { NavigationContent } from "components/Navigation/NavigationContent";
import useNotificationHandler from "hooks/useNotificationHandler";
import { useAtomValue, useSetAtom } from "jotai";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { HelpLauncher } from "help/HelpLauncher";
import { helpLanguageFor } from "help/types";
import { useAppTheme } from "hooks/useAppTheme";
import { EAppSettings, SelectItem } from "library/types";
import { useEffect, useMemo } from "react";
import { useAppSettings } from "hooks/useAppSettings";
import { useUserData } from "state/queries/useUserData";
import { buildYupLocale } from "validation";
import { panelIsOpenState, darkModeState, userRolesState } from "../../store";

const AppHeader = () => {
  const { t, i18n: i18nInstance } = useTranslation();
  const { pathname } = useLocation();
  const theme = useAppTheme();
  const userRoles = useAtomValue(userRolesState);
  const helpViewer = useMemo(() => ({ roles: userRoles }), [userRoles]);
  const { notifications, handleClearAllNotifications } =
    useNotificationHandler();

  const setPanelIsOpen = useSetAtom(panelIsOpenState);
  const setDarkMode = useSetAtom(darkModeState);

  const { data: user } = useUserData();
  const { updateSetting } = useAppSettings();

  const headerConfig = getHeaderConfig(t("qtg.appName.label"));

  useEffect(() => {
    // api.get("/uad/taxonomy");
  }, []);

  return (
    <GrecoHeader
      navigation={<NavigationContent />}
      headerConfig={headerConfig}
      panelStatus={setPanelIsOpen}
      user={user}
      notifications={notifications}
      clearNotifications={handleClearAllNotifications}
      logo={Logo}
      logout={logout}
      darkMode={(isDark: boolean) => setDarkMode(isDark)}
      helpSlot={
        <HelpLauncher
          pathname={pathname}
          viewer={helpViewer}
          language={helpLanguageFor(i18nInstance.resolvedLanguage)}
          notify={(message) => toast.info(message)}
          color={theme.palette.white}
        />
      }
      userManual={userManualFor(i18nInstance.resolvedLanguage, t)}
      languageOptions={[
        {
          value: "en-GB",
          text: t("Language.EN_GB"),
        },
        {
          value: "lv-LV",
          text: t("Language.LV_LV"),
        },
      ]}
      defaultLanguage={i18n.resolvedLanguage}
      onChangeLanguage={async (__event: any, languageOption?: SelectItem) => {
        if (!languageOption) return;

        i18n.changeLanguage(languageOption.value as string);

        updateSetting(
          EAppSettings.language,
          languageOption?.value?.toString() || "",
          false
        );

        buildYupLocale(null, t);
      }}
      headerStrings={{
        notificationsPanelStrings: {
          panelTitle: t("header.Notifications"),
          noNotificationsTitle: t("header.NoNotificationsTitle"),
          noNotificationsSubtitle: t("header.NoNotificationsSubtitle"),
        },
        settingsPanelStrings: {
          panelTitle: t("header.Settings"),
          darkModeToggleLabel: t("header.DarkMode"),
          selectLanguageLabel: t("header.SelectLanguage"),
        },
        userSettingsPanelStrings: {
          panelTitle: t("header.UserSettings"),
          myOfficeProfileLinkText: t("header.MyOfficeProfile"),
          myAccountLinkText: t("header.UserSettings"),
          signOutLinkText: t("header.SignOut"),
        },
      }}
    />
  );
};

/** The user manual PDF (in `public/manuals`) matching the app language; English unless Latvian is selected. */
const userManualFor = (
  language: string | undefined,
  t: (key: string) => string
) => {
  const code = language?.toLowerCase().startsWith("lv") ? "LV" : "EN";
  const fileName = `QTG-User-Manual-${code}.pdf`;
  return {
    href: `${process.env.PUBLIC_URL}/manuals/${fileName}`,
    fileName,
    label: t("header.UserManual"),
  };
};

export default AppHeader;
